/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_ErrorInputs */

const en_contact_form_error = /** @type {(inputs: Contact_Form_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The message did not go through. Try again in a moment.`)
};

const pl_contact_form_error = /** @type {(inputs: Contact_Form_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiadomość nie doszła. Spróbuj za chwilę.`)
};

/**
* | output |
* | --- |
* | "The message did not go through. Try again in a moment." |
*
* @param {Contact_Form_ErrorInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_error = /** @type {((inputs?: Contact_Form_ErrorInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_ErrorInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_error(inputs)
	return en_contact_form_error(inputs)
});